import { Routes } from "@angular/router";
import {authCustomerGuard} from "../../../../core/guards/auth-customer.guard";
import { myVehiclesResponseResolver } from "@modules/customer/myvehicles/resolvers/myvehicles-response.resolver";

export const CUSTOMER_ROUTERS: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('@modules/customer/myorder/myorder.module').then(
        (m) => m.MyorderModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101171',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: '',
    loadChildren: () =>
      import('@modules/customer/tagactivation/tagactivation.module').then(
        (m) => m.TagactivationModule
      ),
  },
  {
    path: 'pagina-inicial',
    loadChildren: () =>
      import('@modules/customer/dashboard/dashboard.module').then(
        (m) => m.DashboardModule),
    canActivate: [authCustomerGuard],
    data: { roles: '101124', contractRequired: true },
  },
  {
    path: 'meus-veiculos',
    loadChildren: () =>
      import('@modules/customer/myvehicles/myvehicles.module').then(
        (m) => m.MyvehiclesModule
      ),
    canActivate: [authCustomerGuard],
    resolve: { profilesUser: myVehiclesResponseResolver },
    data: {
      roles: '101143',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: 'gestao-lote',
    loadChildren: () =>
    import('@modules/customer/batch-management/batch-management.module').then(
      (m) => m.BatchManagementModule),
    canActivate: [authCustomerGuard],
    data: {
      roles: '103003',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: 'hierarquia',
    loadChildren: () =>
      import('@modules/customer/hierarchy/hierarchy.module').then(
        (m) => m.HierarchyModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101162',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: 'recargas',
    loadChildren: () =>
      import('@modules/customer/recharge/recharge.module').then(
        (m) => m.RechargeModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101174',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true,
      prepaidPage: true
    },
  },
  {
    path: 'extrato',
    loadChildren: () =>
      import('@modules/customer/extract/extract.module').then(
        (m) => m.ExtractModule
      ),
    canActivate: [authCustomerGuard],
        data: {
          roles: '101180',
          backofficeRoles: '100994,100995,100996',
          contractRequired: true
        },
  },
  {
    path: 'passagens',
    loadChildren: () =>
      import('@modules/customer/tickets/tickets.module').then(
        (m) => m.TicketsModule
      ),
    canActivate: [authCustomerGuard],
        data: {
          roles: '101187',
          backofficeRoles: '100994,100995,100996',
          contractRequired: true
        },
  },
  {
      path: 'faturas',
      loadChildren: () =>
        import('@modules/customer/bill/bill.module').then(
          (m) => m.BillModule
        ),
      canActivate: [authCustomerGuard],
      data: {
        roles: '101193',
        backofficeRoles: '100994,100995,100996',
        contractRequired: true
    },
  },
  {
    path: 'indicadores-frota',
    loadChildren: () =>
      import('@modules/customer/fleet-dashboard/fleet-dashboard.module').then(
        (m) => m.FleetDashboardModule
      ),
    canActivate: [authCustomerGuard],
    data: { 
      roles: '101222', 
      backofficeRoles: '100996',
      contractRequired: true 
    },
  },
  {
    path: 'saldovpr-veiculos',
    loadChildren: () =>
      import('@modules/customer/saldovpr-veiculos/saldovpr-veiculos.module').then(
        (m) => m.SaldovprVeiculosModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101212',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: 'creditos-recebidos',
    loadChildren: () =>
      import('@modules/customer/vpr-credit-received/vpr-credit-received.module').then(
        (m) => m.VprCreditReceivedModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101214',
      backofficeRoles: '100994,100995,100996',
      contractRequired: true
    },
  },
  {
    path: 'contrato',
    loadChildren: () =>
      import('@modules/customer/mycontract/mycontract.module').then(
        (m) => m.MycontractModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101136',
      contractRequired: true
    },
  },
  {
    path: 'minha-conta',
    loadChildren: () =>
      import('@modules/customer/customer-account/customer-account.module').then(
        (m) => m.CustomerAccountModule
      ),
    canActivate: [authCustomerGuard],
    data: {
      roles: '101134',
      backofficeRoles: '0',
      contractRequired: true
    },
  },
  {
    path: 'fale-conosco',
    loadChildren: () =>
      import('@modules/customer/contact-us/contact-us.module').then(
        (m) => m.ContactUsModule
      ),
  },
  {
    path: 'regras-de-uso',
    loadChildren: () => import('@modules/customer/rules-of-use/rules-of-use.module').then(
      (m) => m.RulesOfUseModule
    ),
    // TODO - Este canActive será temporário até que todo épico esteja implementado
    canActivate: [],
  }
]
